import { c as _c } from "react/compiler-runtime";
import { useIsClient } from 'usehooks-ts';
import IconControlBarLike from '@/components/assets/icon_control_bar_like.svg';
import IconControlBarLikeActive from '@/components/assets/icon_control_bar_like_active.svg';
import IconFavoriteDisable from '@/components/assets/icon_favorite_disable.svg';
import IconFavoriteEnable from '@/components/assets/icon_favorite_enable.svg';
import ViverseButton, { type ViverseButtonProps } from '@/components/ViverseButton';
import { useAuthContext } from '@/context/AuthContext';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
type LikeButtonProps = {
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  showCount?: boolean;
  size?: ViverseButtonProps['size'];
  onSignedOutClick?: () => void;
  variant?: 'controlBar' | 'default';
};
export default function LikeButton(t0) {
  const $ = _c(29);
  const {
    className,
    iconClassName,
    labelClassName,
    onSignedOutClick,
    showCount: t1,
    size,
    variant: t2
  } = t0;
  const showCount = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "default" : t2;
  const {
    isSignedIn
  } = useAuthContext();
  const {
    toggleLikeRoom,
    isLikeButtonEnabled,
    likeCountWithKilo,
    roomData
  } = useCheckEnterRoomContext();
  const t = useTranslations();
  const isLiked = roomData.is_liked;
  const isControlBar = variant === "controlBar";
  const IconLike = isControlBar ? isLiked ? IconControlBarLikeActive : IconControlBarLike : isLiked ? IconFavoriteEnable : IconFavoriteDisable;
  const isClient = useIsClient();
  let t3;
  if ($[0] !== isSignedIn || $[1] !== onSignedOutClick || $[2] !== toggleLikeRoom) {
    t3 = () => {
      if (!isSignedIn && onSignedOutClick) {
        onSignedOutClick();
        return;
      }
      toggleLikeRoom();
    };
    $[0] = isSignedIn;
    $[1] = onSignedOutClick;
    $[2] = toggleLikeRoom;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClick = t3;
  const t4 = isControlBar && isLiked && "bg-control-bar-like-active hover:bg-control-bar-like-active-hover";
  let t5;
  if ($[4] !== className || $[5] !== t4) {
    t5 = cn("group flex min-w-fit gap-2", className, t4);
    $[4] = className;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = !isLikeButtonEnabled || !isClient;
  let t7;
  if ($[7] !== t) {
    t7 = t("action-list.like");
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = isControlBar ? "group-disabled:[&>path]:fill-vive-primary-70 size-4 shrink-0 @[954px]:size-5" : "group-hover:[&>path]:fill-vive-brand-50 size-[18px]";
  const t9 = !isControlBar && isLiked && "[&>path]:fill-vive-brand-50";
  const t10 = !isControlBar && iconClassName;
  let t11;
  if ($[9] !== t10 || $[10] !== t8 || $[11] !== t9) {
    t11 = cn(t8, t9, t10);
    $[9] = t10;
    $[10] = t8;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== IconLike || $[14] !== t11) {
    t12 = <IconLike className={t11} />;
    $[13] = IconLike;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== labelClassName || $[17] !== likeCountWithKilo || $[18] !== showCount) {
    t13 = showCount && <span className={labelClassName}>{likeCountWithKilo}</span>;
    $[16] = labelClassName;
    $[17] = likeCountWithKilo;
    $[18] = showCount;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== handleClick || $[21] !== isLiked || $[22] !== size || $[23] !== t12 || $[24] !== t13 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t14 = <ViverseButton className={t5} variant="filter" size={size} onClick={handleClick} disabled={t6} aria-label={t7} aria-pressed={isLiked}>{t12}{t13}</ViverseButton>;
    $[20] = handleClick;
    $[21] = isLiked;
    $[22] = size;
    $[23] = t12;
    $[24] = t13;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}